import { FiGithub, FiExternalLink, FiLock } from 'react-icons/fi';

/**
 * ProjectCard — reusable React component for a single project entry.
 * Props: title, desc, tags[], color, Icon, link, github
 * link/github can be null for private/confidential projects.
 */
export default function ProjectCard({ title, desc, tags, color, Icon, link, github }) {
  const handleCardClick = () => {
    if (link) window.open(link, '_blank', 'noreferrer');
  };

  return (
    <div
      className="project-card"
      onClick={handleCardClick}
      style={{ cursor: link ? 'pointer' : 'default' }}
    >
      <div className="card-shine" />
      <div
        className="card-accent-line"
        style={{ background: `linear-gradient(90deg, ${color}, var(--accent-dk))` }}
      />

      <div className="project-icon-wrap">
        <Icon className="project-svg-icon" style={{ color }} />
      </div>

      <h3 className="project-title">{title}</h3>
      <p className="project-desc">{desc}</p>

      <div className="project-tags">
        {tags.map((t, j) => (
          <span key={j} className="tag">{t}</span>
        ))}
      </div>

      <div className="project-links">
        {github ? (
          <a
            href={github}
            target="_blank"
            rel="noreferrer"
            className="proj-link"
            onClick={(e) => e.stopPropagation()}
          >
            <FiGithub /> GitHub
          </a>
        ) : (
          <span className="proj-link proj-link-private">
            <FiLock /> Private
          </span>
        )}

        {link ? (
          <a
            href={link}
            target="_blank"
            rel="noreferrer"
            className="proj-link primary"
            onClick={(e) => e.stopPropagation()}
          >
            <FiExternalLink /> Live Demo
          </a>
        ) : (
          <span className="proj-link proj-link-private">
            <FiLock /> Confidential
          </span>
        )}
      </div>
    </div>
  );
}
